module.exports = __webpack_public_path__ + "static/winter-01-b2cb9899c0b4c88684b99cfb4e9dcb6f.jpg";